import React from "react";
import MetaData from "../../components/layout/MetaData";

const faqs = [
  {
    question: "How do I learn PCBA info?",
    answer: [
      "These professional electronic design and manufacturing businesses deliver fee-based services to assist you with the design, development and production of your concepts, products and services. The website allows you to search for providers based on industry, design capabilities, certifications and practical experience. Available services include hardware and software design, schematic design, PCB layout, prototype assembly & testing, high-volume manufacturing and various related support services.",
      "Simply send your product introductions to hello@creatyea.com or fill in below information and submit requests",
    ],
  },
];

/**
 * FAQ页面，展示从Word文档整理出的常见问题内容。
 */
export default function FaqPage() {
  return (
    <>
      <MetaData title="FAQ" />
      <main className="customer-main-content with-top-clearance-margin">
        <div className="creatyea-padding contact-us-section">
          <div className="container-fluid">
            <h1>FAQ</h1>
            {faqs.map((faq, index) => (
              <section key={index} className="mt-4">
                <h3 className="text-xl font-semibold">{faq.question}</h3>
                {faq.answer.map((paragraph, paragraphIndex) => (
                  <p key={paragraphIndex}>{paragraph}</p>
                ))}
              </section>
            ))}
          </div>
        </div>
      </main>
    </>
  );
}
